'use strict'

import ue4 from './ue4/cirrus.js'
// import ue5 from './ue5/SignallingWebServer/cirrus.js'
import ue5 from './ue5.1/SignallingWebServer/cirrus.js'

const controller = new class {
  cb() {
    if (typeof window !== 'undefined') {
      console.log('@@@ window opened')
      window.open('https://ps-dev.metaeditor.io/dev/')
    }
  }
  ue4(config) {
    ue4.start(config, this.cb)
  }
  ue5(config) {
    ue5.start(config, this.cb)
  }
}

// controller.ue5({})

export default controller


// import pkg from '../package.json'
// console.log(pkg.description)
// console.log(`Version: ${pkg.version}`)
// console.log(`Author: ${pkg.author}`)
// console.log(`Licence: ${pkg.license}`)
// console.log(`Repository: ${pkg.homepage}`)
